import { render, staticRenderFns } from "./assistentes.vue?vue&type=template&id=6518b064"
import script from "./assistentes.vue?vue&type=script&lang=js"
export * from "./assistentes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports